import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { Box } from '../../ui/Box';

import { SupplierCompanyMultiSelect, type SupplierCompanyMultiSelectProps } from './SupplierCompanyMultiSelect';

// To be used at overview pages within a flex container

interface OverviewSupplierCompanySelectProps
    extends Omit<SupplierCompanyMultiSelectProps, 'dropdownWidth' | 'placeholder'> {}

export const OverviewSupplierCompanySelect = (props: OverviewSupplierCompanySelectProps) => {
    const role = useRole();
    return (
        <Box minWidth="250px">
            <SupplierCompanyMultiSelect
                {...props}
                dropdownWidth="520px"
                placeholder={
                    role.isSuperAdmin()
                        ? translate('placeholder.filter.supplier')
                        : translate('placeholder.filter.company')
                }
                clearSearchOnSelect={false}
            />
        </Box>
    );
};
